import { render } from "./designer.vue?vue&type=template&id=4403ae94&scoped=true"
import script from "./designer.vue?vue&type=script&lang=js"
export * from "./designer.vue?vue&type=script&lang=js"

import "./designer.vue?vue&type=style&index=0&id=4403ae94&scoped=true&lang=css"

import exportComponent from "D:\\1\\2023-02-15\\doubles-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4403ae94"]])

export default __exports__